import React from 'react';
import messageCenterCommonStyles from 'MessageCenter/Common.module.css'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { pnDueActions } from '_actions';

class ProgressDueListItem extends React.Component {
    render() {
        return (
            <div
                className={
                    this.props.id === this.props.selectedMessage ? messageCenterCommonStyles.selected_message :
                        this.props.message.isRead === true ? messageCenterCommonStyles.read_message : messageCenterCommonStyles.unread_message
                }
                onClick={() => this.props.changeMessage(this.props.id)}>
                {this.props.message.ptname}
            </div>
        );
    }
}

function mapStateToProps(state, ownprops) {
    return {
        message: state.entities.pnDue[ownprops.id],
        selectedMessage: state.ui.pnDue.selectedMessage,
    };
}


function mapDispatchToProps(dispatch) {
    return {
        changeMessage: bindActionCreators(pnDueActions.changeSelection, dispatch)
    };
}

const connectedProgressDueListItem = connect(mapStateToProps, mapDispatchToProps)(ProgressDueListItem);
export { connectedProgressDueListItem as ProgressDueListItem };